/* eslint-disable linebreak-style */
/**
 * Request Wrapper
 */

import { AuthRequestWrapper, AuthRequestWrapperConfig } from 'react-auth';
import getConfig from 'next/config';
import get from 'base-ui/dist/underline/get';
import { log } from 'root/utils/raven';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {}; // https://github.com/zeit/next.js/issues/4024#issuecomment-377837421

/**
 * Request Wrapper Configurations
 */
export const requestWrapperConfig = (config) => {
  const headers = {
    ...(config || {}),
    'X-MC-ALIAS': publicRuntimeConfig.APP_THEME,
    'X-APP-VERSION': publicRuntimeConfig.VERSION,
    'X-MC-PLATFORM': 'blog',
    'X-MC-ENV': 'web',
    'X-MC-KEY': publicRuntimeConfig.X_MC_KEY || 'courses',
  };
  AuthRequestWrapperConfig.setUp({
    baseURL: `${config?.baseURL || publicRuntimeConfig.API_URL}`,
    crossDomain: true,
    headers,
    logFormat: publicRuntimeConfig.LOG_REQUESTS || 'none',
    log
  });
};

/**
 * Add custom user-agent on request
 * @param req
 */
export const requestWrapperUserAgent = (req) => {
  const ua = get(req, 'headers.user-agent', false);
  requestWrapperConfig({
    'user-agent': ua ? `${ua} SSR MContigo` : 'SSR MContigo',
    referer: get(req, 'url', undefined)
  });
};

export const requestWrapperUserToken = (req) => {
  const cookie = get(req, 'headers.cookie', null);
  if (!cookie) return;
  const cookieItens = cookie.split(';');
  const userToken = cookieItens.find((str) => str.trim().startsWith('user_token'));
  if (!userToken) return;
  const token = userToken.split('=')[1];
  requestWrapperConfig({
    authorization: `Bearer ${token}`
  });
};

requestWrapperConfig(null);

export default AuthRequestWrapper;
